import * as htmlToImage from "html-to-image";
import type { ExportFormat } from "@/lib/types";

type ExportOptions = {
  node: HTMLElement;
  format: ExportFormat;
  quality: number;
};

export async function exportPreviewImage({
  node,
  format,
  quality,
}: ExportOptions) {
  const dataUrl =
    format === "png"
      ? await htmlToImage.toPng(node, {
          pixelRatio: 3,
          cacheBust: true,
          backgroundColor: "transparent",
        })
      : await htmlToImage.toJpeg(node, {
          pixelRatio: 3,
          cacheBust: true,
          quality: quality / 100,
          backgroundColor: "#ffffff",
        });

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = `linkedin-post-beautified.${format}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
}
